<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <vc-layout :spacing="spacing" :class="['list-examples']">
      <vc-col :span="12" md12 sm24>
        <example-title src="example-1.html" title="Two lines, avatar and right icon" />
        <vc-list>
          <vc-list-item v-for="i in 3" :key="i" :avatar="`/static/images/avatar-0${i}.png`" icon="account_circle">
            <vc-list-item-primary-text>User {{ i }}</vc-list-item-primary-text>
            <vc-list-item-secondary-text>Admin</vc-list-item-secondary-text>
          </vc-list-item>
        </vc-list>
      </vc-col>
      <vc-col :span="12" md12 sm24>
        <example-title src="example-2.html" title="Two liner and icon on the left" />
        <vc-list>
          <vc-list-item  v-for="i in 3" :key="i" avatar="camera">
            <vc-list-item-primary-text>Camera {{ i }}</vc-list-item-primary-text>
            <vc-list-item-secondary-text>Secondary Text</vc-list-item-secondary-text>
          </vc-list-item>
        </vc-list>
      </vc-col>
      <vc-col :span="12" md12 sm24>
        <example-title src="example-3.html" title="One liner, no icons" />
        <vc-list>
          <vc-list-item v-for="i in 5" :key="i">
            <vc-list-item-primary-text>List item {{ i }}</vc-list-item-primary-text>
          </vc-list-item>
        </vc-list>
      </vc-col>
      <vc-col :span="12" md12 sm24>
        <example-title src="example-4.html" title="Two lines, left and right icon" />
        <vc-list>
          <vc-list-item avatar="home" icon="account_circle" v-for="i in 3" :key="i">
            <vc-list-item-primary-text>Primary Text {{ i }}</vc-list-item-primary-text>
            <vc-list-item-secondary-text>Secondary Text {{ i }}</vc-list-item-secondary-text>
          </vc-list-item>
        </vc-list>
      </vc-col>
      <vc-col :span="12" md12 sm24>
        <example-title src="example-5.html" title="Two lines and icon on the right" />
        <vc-list>
          <vc-list-item icon="account_circle" v-for="i in 3" :key="i">
            <vc-list-item-primary-text>Primary Text {{ i }}</vc-list-item-primary-text>
            <vc-list-item-secondary-text>Secondary Text {{ i }}</vc-list-item-secondary-text>
          </vc-list-item>
        </vc-list>
      </vc-col>
      <vc-col :span="12" md12 sm24>
        <example-title src="example-6.html" title="Two lines and icon on the right, no divider" />
        <vc-list :divider="false">
          <vc-list-item icon="home" v-for="i in 3" :key="i">
            <vc-list-item-primary-text>Primary Text {{ i }}</vc-list-item-primary-text>
            <vc-list-item-secondary-text>Secondary Text {{ i }}</vc-list-item-secondary-text>
          </vc-list-item>
        </vc-list>
      </vc-col>
      <vc-col :span="8" md12 sm24>
        <example-title src="example-7.html" title="Vue Router links" />
        <vc-list>
          <vc-list-item avatar="panorama_wide_angle" icon="chevron_right" tag="router-link" to="/components/button">
            <vc-list-item-primary-text>Button</vc-list-item-primary-text>
            <vc-list-item-secondary-text>Vuecidity Component</vc-list-item-secondary-text>
          </vc-list-item>
          <vc-list-item avatar="mdi-toggle-switch" icon="chevron_right" tag="router-link" to="/form-elements/switcher">
            <vc-list-item-primary-text>Switcher</vc-list-item-primary-text>
            <vc-list-item-secondary-text>Vuecidity Form Element</vc-list-item-secondary-text>
          </vc-list-item>
          <vc-list-item avatar="tab" icon="chevron_right" tag="router-link" to="/components/tabstrip">
            <vc-list-item-primary-text>Tabs</vc-list-item-primary-text>
            <vc-list-item-secondary-text>Vuecidity Component</vc-list-item-secondary-text>
          </vc-list-item>
        </vc-list>
      </vc-col>
      <vc-col :span="8" md12 sm24>
        <example-title src="example-8.html" title="HTML links" />
        <vc-list>
          <vc-list-item icon="link" avatar="mdi-language-html5" tag="a" target="_blank" to="https://wemakesites.net">
            <vc-list-item-primary-text>wemakesites.net</vc-list-item-primary-text>
            <vc-list-item-secondary-text>My portfolio</vc-list-item-secondary-text>
          </vc-list-item>
          <vc-list-item icon="link" avatar="mdi-wordpress" tag="a" target="_blank" to="https://martinivanov.net">
            <vc-list-item-primary-text>martinivanov.net</vc-list-item-primary-text>
            <vc-list-item-secondary-text>My blog</vc-list-item-secondary-text>
          </vc-list-item>
          <vc-list-item icon="link" avatar="mdi-language-javascript" tag="a" target="_blank" to="https://vueribbon.com">
            <vc-list-item-primary-text>vueribbon.com</vc-list-item-primary-text>
            <vc-list-item-secondary-text>MS Office ribbon for VueJs</vc-list-item-secondary-text>
          </vc-list-item>
        </vc-list>
      </vc-col>
      <vc-col :span="8" md12 sm24>
        <example-title src="example-9.html" title="@click (open console)" />
        <vc-list>
          <vc-list-item @click="onClick('https://wemakesites.net')" :class="['click-target']" icon="mdi-language-html5" avatar="/static/images/vuecidity.svg">
            <vc-list-item-primary-text>wemakesites.net</vc-list-item-primary-text>
            <vc-list-item-secondary-text>My portfolio</vc-list-item-secondary-text>
          </vc-list-item>
          <vc-list-item @click="onClick('https://martinivanov.net')" :class="['click-target']" icon="mdi-wordpress" avatar="/static/images/vuecidity.svg">
            <vc-list-item-primary-text>martinivanov.net</vc-list-item-primary-text>
            <vc-list-item-secondary-text>My blog</vc-list-item-secondary-text>
          </vc-list-item>
          <vc-list-item @click="onClick('https://vueribbon.com')" :class="['click-target']" icon="mdi-language-javascript" avatar="/static/images/vuecidity.svg">
            <vc-list-item-primary-text>vueribbon.com</vc-list-item-primary-text>
            <vc-list-item-secondary-text>MS Office ribbon for VueJs</vc-list-item-secondary-text>
          </vc-list-item>
        </vc-list>
      </vc-col>
    </vc-layout>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'ListPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      spacing: 8
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    onClick (url) {
      console.log('vc-list-item:click', url)
    }
  }
}
</script>
<style>
.list-examples .title
{
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/list.vue